var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"iconify iconify--mdi",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","aria-hidden":"true","role":"img","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }